<template>
  <v-card class="back" style="height: 400px">
    <v-layout fill-height>
      <v-flex >
        <v-layout column fill-height>
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span class="body-2 text-uppercase">{{$t('test')}}</span>
                </v-toolbar-title>

                <v-layout justify-end>
                <v-tooltip dark color="secondary" bottom>
                  <v-btn icon flat 
                    slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'close'"
                    @click="()=>{$emit('close')}"
                  >
                    <svg-icon
                      :color="'white'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('close') }}</span>
                </v-tooltip>
              </v-layout>

              </v-toolbar>             
            </template>

            <template slot="body">
              <v-layout column fill-height justify-start class="pa-2">
                <v-form ref="e_mail_card_form">
                  
                  <v-layout shrink v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true'" >
                    <v-flex xs4 shrink v-if="field.name != 'push_active'" px-0 pb-2>
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        hide-details                      
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>
                    
                    <v-flex xs8 shrink px-0 pb-2>

                      <v-tooltip v-if="getDescriptions[field]" dark color="secondary" bottom>

                        <v-text-field
                          v-if="field.type == 'integer'"
                          slot="activator"
                          :data-testid="$options.name + '__text-field_integer__' + field.name"
                          v-model.number="model.obj[field.name]"
                          :type="'number'"
                          light
                          outline
                          class="white"
                          hide-details                     
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>

                        <v-text-field
                          v-else
                          slot="activator"
                          :data-testid="$options.name + '__text-field__' + field.name"
                          v-model="model.obj[field.name]"
                          light
                          outline
                          class="white"
                          hide-details                     
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>
                        <span >{{ $t(getDescriptions[field.name]) }}</span>
                      </v-tooltip>

                      <v-text-field
                        v-if="!getDescriptions[field.name] && field.type == 'integer'"
                        :data-testid="$options.name + '__text-field_integer__' + field.name"
                        v-model.number="model.obj[field.name]"
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        :required="model.fields[field.name].required"
                        :type="'number'"
                        validate-on-blur
                        light
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-text-field
                        v-if="!getDescriptions[field.name] && field.type == 'text' && field.name != 'password' && field.name != 'push_active'"
                        :data-testid="$options.name + '__text-field_text__' + field.name"
                        v-model="model.obj[field.name]"
                        :rules=[eRule]
                        required
                        light
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-text-field
                        v-if="!getDescriptions[field.name] && field.type == 'text' && field.name == 'password'"
                        :data-testid="$options.name + '__text-field_password__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :type="visible ? 'text' : 'password'"
                        @click:append="() => (visible = !visible)"
                        :append-icon="visible ? 'visibility' : 'visibility_off'"
                        :rules="[v => !!v || $t('required')]"
                        required
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-select
                        v-if="(field.type == 'select' || field.type == 'select_enum')"
                        :data-testid="$options.name + '__select__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        required
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        outline
                        class="white"
                        background-color="backgrey"
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                      </v-select>

                      <v-checkbox
                        small
                        light
                        color="secondary"
                        v-if="field.type == 'boolean' || field.name == 'push_active'"
                        :data-testid="$options.name + '__checkbox__' + field.name"
                        v-model="model.obj[field.name]"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>

                    </v-flex>

                  </v-layout>
                </v-form>
              </v-layout>
            </template>

            <template slot="footer">
              <v-layout fill-height>
                <v-layout fill-height justify-start>

                  <v-btn small color="success"
                    :disabled="!eRule(model.obj.email)"
                    :data-testid="$options.name + '__footer_btn__' + 'test'"
                    @click="()=>saveData()" 
                  >{{$t('test')}}</v-btn>

                </v-layout>
                <v-layout fill-height justify-end>
                  <v-btn small  color="grey"
                    :data-testid="$options.name + '__footer_btn__' + 'close'"
                    @click="()=>{$emit('close')}"
                  >{{$t('close')}}</v-btn>                 
                </v-layout>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface FieldItem {
  name: string
  type: string
  value: any
  place: string
  group: string
  polling: string | null
  show: string
  required: boolean
  default: boolean
}

interface ModelData {
  fields: Record<string, FieldItem>
  obj: Record<string, any>
  items: Record<string, any>
  refs: Record<string, any>
}

interface DescriptionsData {
  [key: string]: any
}

interface EmailData {
  $id?: string
  [key: string]: any
}

interface ParentData {
  [key: string]: any
}

export default Vue.extend({
  name: 'E_MAIL_CARD',

  components: {
    scrollArea,
    svgIcon,
  },

  props: {
    data: {
      type: Object as () => EmailData,
      default: () => ({})
    },
    parentData: {
      type: Object as () => ParentData,
      default: () => ({})
    },
    descriptions: {
      type: Object as () => DescriptionsData,
      default: () => ({})
    },
  },

  data(): {
    editMode: boolean
    rowData: any[]
    err: string
    meta: any | null
    model: ModelData
    visible: boolean
  } {
    return {
      editMode: false,
      rowData: [],
      err: '',
      meta: null,
      model: {
        fields: {},
        obj: {},
        items: {},
        refs: {},
      },
      visible: false,
    }
  },

  computed: {
    getData(): EmailData {
      return this.data
    },
    getFields(): Record<string, FieldItem> {
      return this.model.fields
    },
    getItems(): Record<string, any> {
      return this.model.items
    },
    getDescriptions(): DescriptionsData {
      return this.descriptions
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.$set(this.model, 'fields', {})
      this.$set(this.model, 'items', {})
      this.$set(this.model, 'obj', {})
      this.$set(this.model, 'refs', {})
      this.prepareEmailField()
    },

    prepareEmailField(): void {
      this.$set(this.model.fields, 'email', {
        name: 'email',
        type: 'text',
        value: null,
        place: 'main',
        group: 'main',
        polling: null,
        show: 'true',
        required: true,
        default: false,
      })
    },

    async saveData(): Promise<void> {
      try {
        let valid = true

        if (!this.required(this.model.obj.email)) {
          valid = false
          return
        }
        if (!this.emailRule(this.model.obj.email)) {
          valid = false
          return
        }
        if (!valid) return

        const test = await this.$bridge.customQuery('alarm', 'email/testEmail', { mail: this.model.obj.email }, 'post')
        if (test) {
          this.$dialog.notify.success('Тестовое сообщение отправлено!', { timeout: 5000 })
        } else {
          this.$dialog.notify.error('Something wrong!', { timeout: 5000 })
        }
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    setErrorMessage(err: string): boolean {
      this.$dialog.notify.error(err, { timeout: 5000 })
      return false
    },

    required(v: any): boolean {
      if (!!v) return true
      this.setErrorMessage('Поле должно быть заполнено')
      return false
    },

    eRule(value: string): boolean {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const resp = pattern.test(value)
      console.log('eRule', value, resp)
      return resp
    },

    emailRule(value: string): boolean {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (pattern.test(value)) {
        return true
      } else {
        if (value.length) {
          this.setErrorMessage('Некорректный e-mail')
          return false
        }
        return false
      }
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
